'use client';

import { useParams } from 'next/navigation';
import React from 'react';

import ListBarUsecase from '@/components/list-bar/ListBarUsecase';
import { useRouter } from '@/provider/RouterProvider';

import ListUsecase from '../../ListUsecase';
import useUseCase from '../../useUseCase';

const CategoryContent: React.FC = () => {
  const [openFilter, setOpenFilter] = React.useState(false);
  const params = useParams();
  const router = useRouter();
  const tag = params.id;

  const { list, loading, currentPage, loadMore } = useUseCase(typeof tag === 'string' ? tag : '');

  const handleClearFilter = React.useCallback(() => {
    setOpenFilter(false);
    router.push(`/template/category/${tag}/`, { scroll: false }, { noLoadBar: true });
  }, []);

  return (
    <div className="mx-auto max-w-[1740px] px-[20px] 4xl:max-w-none 4xl:px-0">
      <div className="px-[40px] py-10 md:px-[20px]">
        <div className="relative">
          <h1 className="mb-10 text-center text-[40px] font-bold capitalize text-black sm:text-[26px]">
            {tag}
          </h1>
        </div>
        <ListBarUsecase
          handleClearFilter={handleClearFilter}
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          hasTags={false}
        />
        <ListUsecase
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          list={list}
          loadMore={loadMore}
          currentPage={currentPage}
          // getUseCaseURL={getUseCaseURL}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default CategoryContent;
